import { ExclamationTriangleIcon } from "@radix-ui/react-icons"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { useWallets } from "@/api/wallets"
import { Link } from "react-router-dom"

export function BackupAlert() {
  const { wallet } = useWallets()

  if (!wallet || (wallet && wallet.walletBackups.length > 0)) {
    return null
  }

  return (
    <Alert>
      <ExclamationTriangleIcon className="h-4 w-4" />
      <AlertTitle>Back up Your Wallet</AlertTitle>
      <AlertDescription className="flex justify-between items-center gap-2">
        To ensure you never lose access to your funds, make sure to backup your
        wallet
        <Button size="sm" variant="outline" asChild className="-mt-5">
          <Link to="/settings/wallet">Backup Wallet</Link>
        </Button>
      </AlertDescription>
    </Alert>
  )
}
